//Gerar codigo semelhante a ./meiopag.model.ts substituindo meiopag por estoque
import { M } from "react-router/dist/development/route-data-H2S3hwhf";
import { Dispatch } from "../../controller";
import { Estoque, EstoqueItemView, ItemMov, Movimentacao } from "../../data.types";
import { Model,StateProps } from "../../model";

export type { Estoque } from "../../data.types";

export interface EstoqueState extends StateProps<Estoque> {
    estoqueItemView: EstoqueItemView[]
}

export interface EstoqueActions extends Dispatch<Estoque> {
    configEstoque:(estabilizar: boolean) => any;
    readEstoque:()=>any;
    salvarEstoqueAtualizado:()=>any
    reConfigEstoque: () => any
    estabilizaEstoque:(itensMov:ItemMov[]) => any
}

const model = new Model<Estoque,EstoqueState>("estoque");

const intialValueEstoque:Estoque = {
    ...model.getInitialValue(),
    type:"estoque",
    data:"",
    itens:[],
}

export const initialValueEstoqueState:EstoqueState = {
    ...model.getInititalValueState(),
    row:intialValueEstoque,
    estoqueItemView:[],
}


